import { render, staticRenderFns } from "./PostDetails.vue?vue&type=template&id=48f35354&scoped=true"
import script from "./PostDetails.vue?vue&type=script&lang=js"
export * from "./PostDetails.vue?vue&type=script&lang=js"
import style0 from "./PostDetails.vue?vue&type=style&index=0&id=48f35354&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f35354",
  null
  
)

export default component.exports